module.exports = __webpack_public_path__ + "img/newLoginTop.606ea34a.png";